import React from "react";
import "../css/style.css";
import { Button } from "@material-ui/core";
import i18next from "i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { IconButton, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import SaveIcon from "@material-ui/icons/Save";
import personLogo from "../img/person.png";
import { serverUrl } from "../_constants";
import MeetingDialog from "./MeetingDialog/MeetingDialog";

export default function PartItem(props) {
  const anketaField = (field, value) => {
    return (
      <div className="tbl__body-row">
        <div className="tbl__items">
          <div className="tbl__item tbl__item--city">
            <span className="profile__name">{field}</span>
          </div>
          <div className="tbl__item tbl__item--text">
            <span>{value}</span>
          </div>
        </div>
      </div>
    );
  };

  const [anketaOpen, setAnketaOpen] = React.useState(false);
  const [meetingOpen, setMeetingOpen] = React.useState(false);
  const name = props.data ? props.data.user_name : "";
  const avatar = props.data.avatar ? serverUrl + props.data.avatar : personLogo;
  
  const showMeeting = props.forStudent && props.conferenceId && props.data.isMeetingPossible;

  return (
    <div className="tbl__body-row">
      <div className="tbl__items part-table__items">
        <div className="part-table__avatar-col">
          <img src={avatar} alt="" className="profile__img" />
        </div>
        <div className="tbl__item tbl__item--city part-table__name">
          <span className="profile__name">{name}</span>
          {props.isOrg && props.data.status!="active" && (
            <div className="part-table__status">
              {i18next.t("ticket_canceled")}
            </div>
          )}
        </div>
        <div className="tbl__item tbl__item--city part-table__conf">
          <span>{props.data ? props.data.conf_name : ""}</span>
        </div>
        <div className="tbl__item tbl__item--city part-table__details">
          <Button onClick={() => setAnketaOpen(true)}>
            {i18next.t("details")}
          </Button>
        </div>
        {showMeeting ? <div className="tbl__item tbl__item--city part-table__meeting">
          <Button onClick={() => setMeetingOpen(true)}>
            {i18next.t("meeting_request")}
          </Button>
        </div> : ""}
        
        {!props.forStudent && (
          <div className="tbl__item tbl__item--text part-table__ticket">
            <span>{props.data  ?  props.data.ticket_name : ""}</span>
          </div>
        )}
        {!props.forStudent && (
          <div className="tbl__item tbl__item--text part-table__date">
            <span>
              {props.data ? props.data.updated_at.replace(".000000Z", "") : ""}
            </span>
          </div>
        )}
        {props.isOrg && (
          <div className="part-table__actions-col">
            {props.data.status=="active" && (
              <>
                <Tooltip title={i18next.t("download_badge")} aria-label={"download_badge"} style={{fontSize:20}}>
                  <SaveIcon
                      onClick={props.downloadBadge}
                      width="15"
                      height="15"
                    />
                  </Tooltip>
                <Tooltip title={i18next.t("cancel_ticket")} aria-label={"cancel_ticket"} style={{fontSize:20}}>
                  <DeleteIcon
                      onClick={props.cancelTicket}
                      width="15"
                      height="15"
                    />
                </Tooltip>
              </>
            )}
          </div>
        )}
      </div>
      <Dialog open={anketaOpen}>
        <DialogTitle>{name}</DialogTitle>
        <DialogContent>
          {avatar.length > 0 && <img src={avatar} alt="" />}
          {props.data.user_email.length > 0 &&
            anketaField(i18next.t("dialog_email"), props.data.user_email)}
          {Object.keys(props.data.anketa).map((field) => {
            const value = props.data.anketa[field];
            if (typeof value === "object" && value !== null) {
              return anketaField(value.title, value.value);
            }
          })}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAnketaOpen(false)}>
            {i18next.t("btn_cancel")}
          </Button>
        </DialogActions>
      </Dialog>
      {showMeeting ? <MeetingDialog 
        open={meetingOpen}
        closeDialog={() => setMeetingOpen(false)}
        userTo={props.data.user_id}
        conferenceId={props.conferenceId}
      /> : ""}
    </div>
  );
}
